import { useTranslations } from "../../hooks/useTranslations";

type BackButtonProps = {
  onClick: () => void;
  label?: string;
  className?: string;
};

export function BackButton({
  onClick,
  label,
  className = "",
}: BackButtonProps) {
  const t = useTranslations();
  const buttonLabel = label ?? t.back;
  return (
    <button
      type="button"
      className={`festapp-back-btn ${className}`}
      onClick={onClick}
    >
      <div className="festapp-back-btn-inner">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="m15 18-6-6 6-6" />
        </svg>
        <span>{buttonLabel}</span>
      </div>
    </button>
  );
}
